import * as FilePond from 'filepond';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';

FilePond.registerPlugin(FilePondPluginFileValidateSize);

jQuery(document).ready(function($) {
	$('input[type="file"]').each(function() {

		var image = '<img class="file-upload__image" src="/app/themes/perspectiefingezondheid/dist/images/icons/img.svg" alt="Your Image">';
		var button = '<div class="button file-upload__button">Browse</div>';

		FilePond.create(this, {
			maxFileSize: '2MB',
			labelIdle: `<div class="file-upload__container"><div>${image}<span> Upload een bedrijfslogo. Max grootte 2MB </span></div>${button}</div>`
		});
		
	});
});
